import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Logo from "../../assets/images/logo.png";
import Button from "@mui/material/Button";
import { Box } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import { FiUser } from "react-icons/fi";
import { IoBagOutline } from "react-icons/io5";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import { FaClipboardCheck, FaHeart, FaUserAlt } from "react-icons/fa";
import { RiLogoutCircleRFill } from "react-icons/ri";
import { IoMdMenu } from "react-icons/io";
import { fetchDataFromApi } from "../../utils/api";
import "./Header.css"
import { Heart } from "lucide-react";

const Header = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [isOpenNav, setIsOpenNav] = useState(false);
    const [cartData, setCartData] = useState([]);
    const [adminOrder, setAdminOrder] = useState([]);
    const [myListData, setmyListData] = useState([]);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const open = Boolean(anchorEl);

    const headerRef = useRef();
    const history = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("user"));

        if (user?.userId) {
            fetchDataFromApi(`/api/cart?userId=${user?.userId}`).then((res) => {
                setCartData(res);
            });
            fetchDataFromApi(`/api/my-list?userId=${user.userId}`).then((res) => {
                setmyListData(res);
            });
        }


        if (user?.role === "admin") {
            fetchDataFromApi(`/api/orders/`).then((res) => {
                setAdminOrder(res);
            });
        }

        // Handle sticky header logic
        const handleScroll = () => {
            let position = window.pageYOffset;
            if (headerRef.current) {
                if (position > 50) { // Adjusted threshold for stickiness
                    headerRef.current.classList.add("fixed");
                } else {
                    headerRef.current.classList.remove("fixed");
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const logout = () => {
        setAnchorEl(null);
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        localStorage.removeItem("location");
        history("/signIn");
    };

    const user = JSON.parse(localStorage.getItem("user"));

    const renderAvatar = (avatar) =>
        avatar ? (
            <Avatar
                src={avatar}
                alt="Profile"
                sx={{
                    width: { xs: 35, sm: 35, md: 45, lg: 45 },
                    height: { xs: 35, sm: 35, md: 45, lg: 45 },
                }}
            />
        ) : (
            <FiUser />
        );

    const navLinks = [
        { name: "Home", path: "/" },
        { name: "About", path: "/about" },
        { name: "Process", path: "/process" },
        { name: "Product", path: "/product" },
        { name: "Contact", path: "/contact" },
    ];

    return (
        <>
            <div className="headerWrapperFixed" ref={headerRef}>
                <div className="headerWrapper">
                    <header className="header">
                        <div className="container">
                            <div className="row align-items-center"> {/* Added align-items-center for single row */}
                                <div className="logoWrapper d-flex align-items-center"> {/* Removed col-sm-2 */}
                                    <Link to={"/"} className="nav-logo">
                                        <img src={Logo} alt="Logo" />
                                        <small>Royal BeeKeeper</small>
                                    </Link>
                                </div>

                                {/* Navigation Menu for larger screens */}
                                {windowWidth > 993 && (
                                    <nav className="navigation-menu d-flex align-items-center ml-auto">
                                        <ul className="list list-inline mb-0">
                                            {navLinks.map((link, index) => (
                                                <li className="list-inline-item" key={index}>
                                                    <Link
                                                        to={link.path}
                                                        className={location.pathname === link.path ? "active" : ""}
                                                    >
                                                        <Button
                                                            variant="contained"
                                                            sx={{
                                                                boxShadow: location.pathname === link.path ? 1 : 0,
                                                                background: location.pathname !== link.path && "transparent",
                                                                "&:hover": {
                                                                    boxShadow: 1,
                                                                },
                                                            }}
                                                        >
                                                            {link.name}
                                                        </Button>
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </nav>
                                )}

                                <div className="part3 d-flex align-items-center ml-auto">
                                    {user ? (
                                        user?.role === "admin" ? (
                                            <>
                                                <Button
                                                    className="circle"
                                                    onClick={handleClick} // Admin profile dropdown
                                                    sx={{ mr: 1 }}
                                                >
                                                    {renderAvatar(user.avatar)}
                                                </Button>
                                                <Menu
                                                    anchorEl={anchorEl}
                                                    id="accDrop"
                                                    open={open}
                                                    onClose={handleClose}
                                                    onClick={handleClose}
                                                    transformOrigin={{ horizontal: "right", vertical: "top" }}
                                                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                                                >
                                                    <Link to="/admin/dashboard">
                                                        <MenuItem onClick={handleClose}>
                                                            <ListItemIcon>
                                                                <FaUserAlt fontSize="small" />
                                                            </ListItemIcon>
                                                            Dashboard
                                                        </MenuItem>
                                                    </Link>
                                                    <Link to="/admin/orders">
                                                        <MenuItem onClick={handleClose}>
                                                            <ListItemIcon>
                                                                <FaClipboardCheck fontSize="small" />
                                                            </ListItemIcon>
                                                            Orders ({adminOrder?.length || 0})
                                                        </MenuItem>
                                                    </Link>
                                                    <MenuItem onClick={logout}>
                                                        <ListItemIcon>
                                                            <RiLogoutCircleRFill fontSize="small" />
                                                        </ListItemIcon>
                                                        Logout
                                                    </MenuItem>
                                                </Menu>
                                            </>
                                        ) : (
                                            <>
                                                <Button className="circle" onClick={handleClick} sx={{ mr: 1 }}>
                                                    {renderAvatar(user.avatar)}
                                                </Button>
                                                <Menu
                                                    anchorEl={anchorEl}
                                                    id="accDrop"
                                                    open={open}
                                                    onClose={handleClose}
                                                    onClick={handleClose}
                                                    transformOrigin={{ horizontal: "right", vertical: "top" }}
                                                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                                                >
                                                    <Link to="/my-account">
                                                        <MenuItem onClick={handleClose}>
                                                            <ListItemIcon>
                                                                <FaUserAlt fontSize="small" />
                                                            </ListItemIcon>
                                                            My Account
                                                        </MenuItem>
                                                    </Link>
                                                    <Link to="/orders">
                                                        <MenuItem onClick={handleClose}>
                                                            <ListItemIcon>
                                                                <FaClipboardCheck fontSize="small" />
                                                            </ListItemIcon>
                                                            Orders
                                                        </MenuItem>
                                                    </Link>
                                                    <Link to="/my-list">
                                                        <MenuItem onClick={handleClose}>
                                                            <ListItemIcon>
                                                                <FaHeart fontSize="small" />
                                                            </ListItemIcon>
                                                            Wishlist
                                                        </MenuItem>
                                                    </Link>
                                                    <MenuItem onClick={logout}>
                                                        <ListItemIcon>
                                                            <RiLogoutCircleRFill fontSize="small" />
                                                        </ListItemIcon>
                                                        Logout
                                                    </MenuItem>
                                                </Menu>

                                                {/* Cart Icon */}
                                                < div className="cartTab d-flex align-items-center">
                                                    <Box
                                                        className="position-relative"
                                                        sx={{ ml: { xs: 2, md: 3 } }}
                                                    >
                                                        <Link to="/cart">
                                                            <Button className="circle">
                                                                <IoBagOutline />
                                                            </Button>
                                                            <span className="count d-flex align-items-center justify-content-center">
                                                                {cartData?.length > 0 ? cartData.length : 0}
                                                            </span>
                                                        </Link>
                                                    </Box>
                                                </div>
                                                {
                                                    windowWidth > 430 && (
                                                        < div className="cartTab d-flex align-items-center">
                                                            <Box
                                                                className="position-relative"
                                                                sx={{ ml: { xs: 2, md: 3 } }}
                                                            >
                                                                <Link to="/my-list">
                                                                    <Button className="circle">
                                                                        <Heart />
                                                                    </Button>
                                                                    <span className="count d-flex align-items-center justify-content-center">
                                                                        {myListData?.length > 0 ? myListData.length : 0}
                                                                    </span>
                                                                </Link>
                                                            </Box>
                                                        </div>
                                                    )
                                                }

                                                {/* Wishlist Icon for user role (already handled in dropdown, but separate for clarity if needed) */}
                                                {/* <Box className="position-relative" sx={{ ml: { xs: 1, md: 2 } }}>
                                                    <Link to="/my-list">
                                                        <Button className="circle">
                                                            <FaHeart />
                                                        </Button>
                                                    </Link>
                                                </Box> */}
                                            </>
                                        )
                                    ) : (
                                        <Button
                                            component={Link}
                                            to="/signIn"
                                            sx={{
                                                color: "var(--textColor)",
                                                fontWeight: "600",
                                                textTransform: "uppercase",
                                                fontSize: "14px",
                                                "&:hover": {
                                                    backgroundColor: 'transparent',
                                                    color: 'var(--primaryHoverColor)'
                                                }
                                            }}
                                        >
                                            Login
                                        </Button>
                                    )}

                                    {/* Hamburger menu for smaller screens */}
                                    {windowWidth <= 993 && (
                                        <Button
                                            className="circle toggleNav"
                                            onClick={() => setIsOpenNav(!isOpenNav)}
                                            sx={{ ml: { xs: 1, md: 2 } }}
                                        >
                                            <IoMdMenu />
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </header>

                    {/* Responsive Navigation for smaller screens */}
                    {windowWidth <= 993 && (
                        <nav className={`res-nav-wrapper ${isOpenNav ? "open" : "close"}`}>
                            <div className="res-nav-overlay" onClick={() => setIsOpenNav(false)}></div>
                            <ul className="list list-inline res-nav">
                                {navLinks.map((link, index) => (
                                    <li className="list-inline-item" key={index} onClick={() => setIsOpenNav(false)}>
                                        <Link
                                            to={link.path}
                                            className={location.pathname === link.path ? "active" : ""}
                                        >
                                            <Button
                                                variant="contained"
                                                sx={{
                                                    boxShadow: location.pathname === link.path ? 1 : 0,
                                                    background: location.pathname !== link.path && "transparent",
                                                    "&:hover": {
                                                        boxShadow: 1,
                                                    },
                                                }}
                                            >
                                                {link.name}
                                            </Button>
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </nav>
                    )}
                </div>
            </div>
        </>
    );
};

export default Header;